var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient, HttpBackend } from '@angular/common/http';
import { of } from 'rxjs';
import { DwForgetService } from '../components/forget/service/forget.service';
import { DwSystemConfigService } from '../config/config.service';
var DwIamForgetService = /** @class */ (function (_super) {
    __extends(DwIamForgetService, _super);
    function DwIamForgetService(http, httpBackend, configService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.httpBackend = httpBackend;
        _this.configService = configService;
        _this.configService.getConfig().subscribe(function (params) {
            _this.iamUrl = params.iamUrl;
            _this.emcUrl = params.emcUrl;
        });
        return _this;
    }
    /**
     * 取得 [mail驗證碼 / 手機驗證碼].
     *
     * param {string} type: 驗證碼類型, [email: Email] / [telephone: 手機號碼].
     * param {string} value: email 帳號 / 手機號碼.
     * returns {Observable<any>}
     */
    DwIamForgetService.prototype.getVerificationCode = function (type, value) {
        var _url = 'api/emc/v1/verificationCode/' + type + '/' + value + '/changepassword';
        switch (type) {
            case 'email':
            case 'mobilephone':
                return this.http.post(this.emcUrl + _url, {});
            default:
                return of(null);
        }
    };
    /**
     * [忘記密碼]裡的修改密碼.
     *
     * param {*} params, params.account: Email帳號/手機號碼, params.password: 密碼, params.verificationCode: 驗證碼.
     * returns {Observable<any>}
     */
    DwIamForgetService.prototype.updatePassword = function (params) {
        var updateParams = {
            account: params.account,
            password: params.password,
            verificationCode: params.verificationCode
        };
        var http = new HttpClient(this.httpBackend);
        return http.post(this.iamUrl + 'api/iam/v2/user/password/update', updateParams);
    };
    /**
     * 驗證 [E-mail / mobilephone] 是否有重覆.
     *
     * param {string} type: 驗證類型, [email: Email] / [telephone: 手機號碼].
     * param {string} value: email 帳號[email: value] / 手機號碼[telephone: value] .
     * returns {Observable<any>}
     */
    DwIamForgetService.prototype.verifyExist = function (type, value) {
        var http = new HttpClient(this.httpBackend);
        var params = {};
        params[type] = value;
        switch (type) {
            case 'email':
                return http.post(this.iamUrl + 'api/iam/v2/user/email/exist', params);
            case 'telephone': // 這一個接口的入參是{telephone: value}, url 是用mobilephone, 沒有統一, 無法只使用一個變數.
                return http.post(this.iamUrl + 'api/iam/v2/user/mobilephone/exist', params);
            default:
                return of(null);
        }
    };
    return DwIamForgetService;
}(DwForgetService));
export { DwIamForgetService };
